module.exports = __webpack_public_path__ + "static/img/title.63f4d48.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/media5/title.png
// module id = XoDT
// module chunks = 7